module.exports = __webpack_public_path__ + "img/message_illegal.1dbcc4e3.jpeg";